import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/mine-kjop")({
	beforeLoad: () => {
		throw redirect({ to: "/account/steder" });
	},
});
